import React, { useId } from "react";
/**
 * Field: envoltorio label + control + hint + error.
 * Pasa `htmlFor` automáticamente al control hijo si tiene `id`.
 */
export default function Field({ label, hint, error, required = false, children, className = "", id: idProp, }: {
    label?: React.ReactNode;
    hint?: React.ReactNode;
    error?: React.ReactNode;
    required?: boolean;
    children: React.ReactElement;
    className?: string;
    id?: string;
}): any {
    const autoId = useId();
    const id = idProp ?? autoId;
    const child = React.Children.only(children);
    const controlId = child.props?.id ?? id;
    const enhancedChild = React.cloneElement(child, {
        id: controlId,
        "aria-invalid": error ? true : child.props["aria-invalid"],
        "aria-describedby": [error ? `${controlId}-error` : null, hint ? `${controlId}-hint` : null]
            .filter(Boolean)
            .join(" ") || child.props["aria-describedby"],
    });
    return (<div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (<label htmlFor={controlId} className="text-xs font-medium text-fg-muted">
          {label}
          {required && <span className="text-danger ml-0.5">*</span>}
        </label>)}
      {enhancedChild}
      {hint && !error && (<p id={`${controlId}-hint`} className="text-xs text-fg-subtle">
          {hint}
        </p>)}
      {error && (<p id={`${controlId}-error`} className="text-xs text-danger">
          {error}
        </p>)}
    </div>);
}
